var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import DuplicatePersonService from "../../../Services/DuplicatePerson.service";
const DuplicateRefreshModal = (_a) => {
    var modalProps = __rest(_a, []);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Detect New Duplicates", handleSubmit: DuplicatePersonService.triggerDetectedDuplicateViewRefreshJob, saveButtonContents: "Detect New Duplicates", children: _jsx("div", { className: "form-group", children: _jsx("div", { children: "The system will detect duplicates in the background. This process may take some time to finish. New duplicates will not be shown until the process is finished." }) }) })));
};
export default DuplicateRefreshModal;
